/**
 * ABC-SE specific legal copy (Swedish) for Privacy Policy and Terms & Conditions.
 * Overrides the shared (Danish) content in Clothing/Common/HelpCenter/legalContent.js.
 */

export const PRIVACY_TITLE = 'Personuppgiftspolicy';

export const PRIVACY_SECTIONS = [
  {
    blocks: [
      {
        type: 'p',
        text: 'All behandling av personuppgifter och kunddata sker i enlighet med Dataskyddsförordningen (GDPR) samt personuppgiftslagen (SFS 1998:204), kallad PUL i dagligt tal, och lagen om elektronisk kommunikation (SFS 2003:389).',
      },
      {
        type: 'p',
        text: 'Personuppgifter som du lämnar via hemsidan kommer att användas för att kunna hantera din beställning, fakturering, leverans och marknadsföringsåtgärder. Kommunikation kan ske via brev, e-post eller SMS.',
      },
      {
        type: 'p',
        text: 'Behandling av vissa uppgifter kan även ske hos samarbetspartners och systerbolag i den mån sådana är engagerade för fullgörandet av avtalet mellan kund och bolaget.',
      },
      {
        type: 'p',
        text: 'I. Vi använder oss endast av de personuppgifter du meddelat oss i enlighet med gällande dataskyddslagstiftning.',
      },
      {
        type: 'p',
        text: 'II. Uppgifter som rör din person används endast av vårt eget bolag samt våra systerbolag (som ingår i samma koncern) samt av våra samarbetspartners för betalning och leverans för att genomföra mellan oss överenskomna avtal och i första hand för att ta betalt för och skicka varor till den adress som du uppgett.',
      },
      {
        type: 'p',
        text: 'III. Du kan vända dig till vår kundtjänst om du har frågor om dina lagrade data eller vill ändra eller radera dem.',
      },
      {
        type: 'p',
        text: 'IV. När du registrerar dig för vårt nyhetsbrev eller skapat ett konto sparar vi din e-postadress och telefonnummer och använder det i samband med reklam och marknadsundersökningar till dess du avbeställer nyhetsbrevet eller tar bort ditt konto.',
      },
    ],
  },
  {
    title: 'Skydd mot skräppost (CAPTCHA)',
    blocks: [
      {
        type: 'p',
        text: 'För att skydda våra formulär (t.ex. kontaktformuläret) mot skräppost och missbruk använder vi Cloudflare Turnstile. När Turnstile körs i osynligt läge behandlar Cloudflare viss teknisk information om din enhet och webbläsare. Läs mer i Cloudflares integritetstillägg för Turnstile: https://www.cloudflare.com/en-gb/turnstile-privacy-policy/',
      },
    ],
  },
  {
    title: 'AI-assistent i vår administration (Anthropic)',
    blocks: [
      {
        type: 'p',
        text: 'Våra medarbetare kan använda en AI-assistent i vårt interna administrationssystem, till exempel när de besvarar frågor om beställningar, produkter och skolbutiker. Assistenten levereras av Anthropic (Claude). När en medarbetare ställer en fråga som kräver det kan uppgifter från din beställning skickas till Anthropic: namn, kontaktuppgifter, leveransadress, skola och klass, födelsedatum (ålder) samt beställningens innehåll, betalnings- och leveransstatus. Ditt personnummer skickas aldrig till Anthropic. Assistenten har bara tillgång till de uppgifter som medarbetaren själv har behörighet till.',
      },
      {
        type: 'p',
        text: 'Anthropic behandlar uppgifterna som personuppgiftsbiträde för vår räkning och får inte använda dem för egna ändamål, till exempel för att träna AI-modeller. Uppgifterna behandlas i USA; överföringen sker med stöd av EU-kommissionens standardavtalsklausuler i vårt personuppgiftsbiträdesavtal med Anthropic. Den rättsliga grunden är vårt berättigade intresse av att kunna ge snabb och korrekt kundservice och administration (artikel 6.1 f i dataskyddsförordningen). Läs mer i Anthropics integritetspolicy: https://www.anthropic.com/legal/privacy',
      },
    ],
  },
];

export const TERMS_TITLE = 'Köpvillkor';

export const TERMS_SECTIONS = [
  {
    blocks: [
      {
        type: 'p',
        text: 'Avtalet som du hittar nedanför denna text beskriver det som du och ABC-Gruppen kommer överens om när du lägger din beställning. Till exempel beskrivs hur och när du ska betala och hur vi kan hjälpa dig om något blir fel. Kontakta gärna vår kundtjänst om du har några frågor eller om det är något du inte förstår i denna text.',
      },
      { type: 'p', text: '© 2022-06-30 v1.7' },
      {
        type: 'p',
        text: 'Dessa villkor har utformats i enlighet med rådande branschregler samt Konsumentverkets riktlinjer avseende distans- och hemförsäljningsavtal och konsumentköplag.',
      },
    ],
  },
  {
    title: 'TILLÄMPLIGHET',
    blocks: [
      {
        type: 'p',
        text: 'Dessa villkor gäller för avtal om köp av varor ur den studentkollektion som ABC-Gruppen AB org: 556637-9672, (ABC) vid var tid tillhandahåller.',
      },
    ],
  },
  {
    title: 'AVTALETS INGÅENDE',
    blocks: [
      {
        type: 'p',
        text: 'Varor beställs enligt de anvisningar som ABC tillhandahåller. Om inget annat avtalats skriftligen, anses avtalet vara ingånget när kunden lagt sin beställning och den har accepterats av ABC. För beställningar av personer under 18 år krävs i de flesta fall erforderligt samtycke från målsman. I händelse av att en minderårig som har fyllt 16 år tjänat pengar genom eget arbete eller fått genom gåva kan avtal som rör dessa pengar ingås utan målsmans samtycke. Beställningar från personer under 16 år behandlas inte utan målsmans godkännande.',
      },
    ],
  },
  {
    title: 'KUNDENS KONTROLLSKYLDIGHET',
    blocks: [
      {
        type: 'p',
        text: 'ABC bekräftar innehållet i beställningen genom att skicka kunden en eller flera bekräftelser (Orderbekräftelser) till av kunden uppgivna uppgifter för SMS och e-post. Kunden skall kontrollera innehållet i Orderbekräftelsen och snarast från erhållen bekräftelse underrätta ABC om eventuella ändringar och samtliga invändningar rörande innehållet i beställningen.',
      },
    ],
  },
  {
    title: 'AVBESTÄLLNING/ÄNDRING INNAN PRODUKTION',
    blocks: [
      {
        type: 'p',
        text: 'Efter att ABC accepterat kundens beställning uppdrar denne åt sina underleverantörer att producera beställda varor i enlighet med kundens specifikationer. ABC saknar därefter möjlighet till avbeställning gentemot underleverantörerna. Beställning kommer att lämnas till underleverantören inom 14 dagar efter beställningsdatum. Innan beställningen skickats till produktion kan kunden fritt avboka och ändra sin beställning. Därefter gäller reglerna i nedan block ”Generell information om ångerrätt”.',
      },
    ],
  },
  {
    title: 'FAKTURERINGSVILLKOR',
    blocks: [
      {
        type: 'p',
        text: 'Fakturering sker till av kunden angiven adress eller på sätt som överenskommits skriftligen mellan kunden och ABC. Kunden är medveten om att faktura kan komma att adresseras till målsman för kunden. Vid kundfaktura äger ABC rätt att utta expeditionsavgift. Kunden är medveten om att vissa produkter kan komma att faktureras separat från övriga produkter.',
      },
      {
        type: 'p',
        text: 'Vi bryr oss om din ekonomiska trygghet och vill hjälpa dig undvika överskuldsättning. Vi erbjuder en mängd alternativ i olika prisklasser och uppmuntrar dig att aldrig handla för mer än du har råd med. Som tidigare angetts ska betalning vara oss tillhanda senast 30 dagar efter fakturadatum. Ibland önskar man som kund betala senare än så men för att du inte ska lockas att handla över din budget kommer vi, för order som faktureras efter leverans, aldrig förlänga kredittiden utan du har 30 dagar på dig att betala.',
      },
    ],
  },
  {
    title: 'PRIS- OCH BETALNINGSVILLKOR',
    blocks: [
      {
        type: 'p',
        text: 'Pris följer av ABC:s vid var tid gällande prislista och anges inklusive mervärdesskatt samt andra enligt lag tillkommande skatter. Förskottsbetalning gäller om ej annat angivits vid beställningstillfället. Betalning skall vara ABC tillhanda senast 30 dagar efter fakturadatum. Är inte betalning fullgjord senast på förfallodagen utgår dröjsmålsränta enligt lag. ABC äger rätt att ta ut ersättning för skriftlig betalningspåminnelse samt för lagstadgade inkassokostnader. Betalning sker på det sätt som ABC anvisar. Vid försenad betalning äger ABC ingen skyldighet att leverera beställda varor. Kunden är medveten om att fakturan kan komma att administreras av tredje part.',
      },
    ],
  },
  {
    title: 'ETISKA REGLER OCH RÄTT ATT UNDERLÅTA LEVERANS',
    blocks: [
      {
        type: 'p',
        text: 'Kunden garanterar att angiven information för tryck eller märke är laglig i varje hänseende, att det inte utgör intrång i annans rättighet samt att den inte innehåller stötande material. ABC förbehåller sig rätten att underlåta att leverera en beställning om information eller material enligt ovan inte är förenlig med detta avtals etiska regler enligt denna punkt, eller på annat sätt enligt ABC:s bedömning är oetisk.',
      },
      {
        type: 'p',
        text: 'Våra fastlagda etiska regler gällande innehåll i fotoprodukter och texter som tillhandahålls av ABC-Gruppen:',
      },
      {
        type: 'ul',
        items: [
          'Vapen, tillhygge eller annat våldsinslag får inte förekomma på bild eller i text.',
          'Narkotiska preparat, andra droger eller tillhörande attribut får inte förekomma på bild eller i text.',
          'Attribut med rasistisk eller diskriminerande innebörd får inte förekomma på bild eller i text.',
          'Omotiverad nakenhet, obscen text, gest på bild, samt annat som kan upplevas som stötande eller kränkande får inte förekomma på bild.',
        ],
      },
      {
        type: 'p',
        text: 'Vi förbehåller oss rätten att undanta eller ersätta tveksam bild och text från produktion.',
      },
    ],
  },
  {
    title: 'LEVERANS',
    blocks: [
      {
        type: 'p',
        text: 'Kundens beställning levereras vid den tidpunkt och på det sätt som angivits av ABC vid beställning. Om inget angivits sker leverans till den skola eller plats varifrån beställningen hör. ABC reserverar sig för eventuell slutförsäljning. ABC förbehåller sig dessutom rätten att leverera likvärdig ersättningsvara för det fall en vara utgått ur ABC:s produktutbud. Vid outlösta försändelser förbehåller sig ABC rätten att debitera en avgift på 129 kr i expedieringskostnad. Outlösta paket omfattas inte av ångerrätten enligt punkten 5.',
      },
      {
        type: 'p',
        text: 'Vid ett eventuellt inträffande att ABC erbjudit kunden kostnadsfri leverans till skolan men sedermera inte får leverera beställningen till skolan förbehåller sig ABC rätten att i efterhand debitera en fraktkostnad för att istället kunna skicka beställningen till kundens hemadress.',
      },
    ],
  },
  {
    title: 'REKLAMATION',
    blocks: [
      {
        type: 'p',
        text: 'Reklamation ska framställas inom skälig tid från det att fel märkts eller borde ha märkts. Reklamation som framställs senare än sju dagar efter att fel upptäckts kan ej åberopas.',
      },
    ],
  },
  {
    title: 'FEL OCH FELAVHJÄLPNING',
    blocks: [
      {
        type: 'p',
        text: 'Med fel avses att tryck eller märke på vara avviker från av kunden tillhandahållet eller av kunden godkänt material eller att varan i övrigt är behäftad med brister eller fel. ABC ansvarar inte för fel som beror på kunden eller något förhållande på dennes sida.',
      },
      {
        type: 'p',
        text: 'Kunden ansvarar själv för att varor beställs i rätt storlek eller antal. Fel måste rapporteras till ABC senast 14 dagar efter leverans. ABC äger rätt att i första hand på egen bekostnad avhjälpa felet eller företa omleverans om så kan ske inom skälig tid och utan väsentlig olägenhet för kunden. Ersättning vid fel omfattar endast styrkta och skäliga kostnader som uppkommit som direkt följd av felet.',
      },
    ],
  },
  {
    title: 'SÄKERHET OCH PERSONUPPGIFTER',
    blocks: [
      {
        type: 'p',
        text: 'Kunden samtycker genom detta avtal till att ABC lagrar och använder lämnade personuppgifter i följande syften: hantering av beställning, fakturering, leverans och för marknadsföring av ABC eller annan part som ABC har samarbete med. Kunden kan när som helst genom skriftlig anmälan till ABC återkalla samtycket avseende marknadsföring. Föregående kommunikation kan ske via e-post, telefon, brev och SMS. Kunden är även medveten om att detta innebär att uppgifter kan komma att lämnas till tredje part för uppfyllande av nu uppräknade syften eller förpliktelser enligt detta avtal.',
      },
      {
        type: 'p',
        text: 'All behandling av personuppgifter och kunddata sker i enlighet med Dataskyddsförordningen (GDPR) samt personuppgiftslagen (SFS 1998:204), kallad PUL i dagligt tal, och lagen om elektronisk kommunikation (SFS 2003:389).',
      },
      {
        type: 'p',
        text: 'Personuppgifter som du lämnar via hemsidan kommer att användas för att kunna hantera din beställning, fakturering, leverans och marknadsföringsåtgärder. Kommunikation kan ske via brev, telefon, e-post eller SMS.',
      },
      {
        type: 'p',
        text: 'ABC-Gruppen AB förbinder sig att konfidentiellt behandla material, uppgifter och information om kunden som kommer bolaget till känna som en del av ordern. ABC-Gruppen AB lagrar kundens information i enlighet med god datasäkerhetslagstiftning och i enlighet med personuppgiftslagen (PUL). Kundinformation kan delas inom AJAT-gruppens svenska företag där ABC-Gruppen är en del.',
      },
      {
        type: 'p',
        text: 'Behandling av vissa uppgifter kan även ske hos ABC-Gruppen AB:s samarbetspartners och systerbolag i den mån sådana är engagerade för fullgörandet av avtalet mellan kund och bolaget.',
      },
      {
        type: 'p',
        text: 'Vi distribuerar, säljer eller utbyter inte kundinformation till tredje part för marknadsföring utanför AJAT-gruppbolagen, om inte kunden uttryckligen har samtyckt till det. Personlig information som överlämnas till tredje part används endast för att betjäna kunden. Vi samlar in följande information om kunden för var och en av de angivna syftena: a) Leverans av våra tjänster: Namn, adress, e-post och telefonnummer. b) Marknadsföring: Namn, Adress, E-post, Telefonnummer och Köphistorik. c) Användarupplevelse på hemsidan: Online-identifierare som IP-adress och cookies.',
      },
      {
        type: 'p',
        text: 'I. Vi använder oss endast av de personuppgifter du meddelat oss i enlighet med gällande dataskyddslagstiftning.',
      },
      {
        type: 'p',
        text: 'II. Uppgifter som rör din person används av ABC-Gruppen och våra systerbolag (som ingår i samma koncern) samt av våra samarbetspartners för betalning och leverans för att genomföra mellan oss överenskomna avtal och i första hand för att ta betalt för och skicka varor till den adress som du uppgett.',
      },
      {
        type: 'p',
        text: 'III. Du kan vända dig till oss på info@abcgruppen.se om du har frågor om dina lagrade data eller vill ändra eller radera dem.',
      },
      {
        type: 'p',
        text: 'IV. När du registrerar dig för vårt nyhetsbrev eller skapat ett konto sparar vi din e-postadress och telefonnummer och använder det i samband med reklam och marknadsundersökningar till dess du avbeställer nyhetsbrevet eller tar bort ditt konto. Du kan närsomhelst avbeställa nyhetsbrevet genom att kontakta oss på info@abcgruppen.se eller via länken i nyhetsbrevet.',
      },
      {
        type: 'p',
        text: 'V. Vi använder externa partner för att hantera betalningar på hemsidan. Personuppgifter hanteras i enlighet med gällande lagstiftning. Våra partners behandlar personuppgifter främst i syfte att utföra identifikation, kundanalys, kreditkontroll, marknadsföring och affärsutveckling. Personnummer används som kundnummer i kundhanteringssyfte.',
      },
    ],
  },
  {
    title: 'UPPHOVSRÄTT',
    blocks: [
      {
        type: 'p',
        text: 'ABC innehar rättigheterna till material som framställts av ABC eller av ABC anlitad underleverantör. För det fall kunden tillhandahållit egenproducerat underlag för tryck eller märke behåller kunden samtliga rättigheter till detta material.',
      },
    ],
  },
  {
    title: 'MEDDELANDEN OCH KONTAKTUPPGIFTER',
    blocks: [
      {
        type: 'p',
        text: 'Meddelanden mellan kunden och ABC skall ske genom e-post eller brev till parternas i avtalet angivna eller senare genom till motparten skriftligen meddelade ändrade kontaktuppgifter. Kunden är skyldig att utan dröjsmål meddela ABC om förändringar i sina kontaktuppgifter.',
      },
    ],
  },
  {
    title: 'GENERELL INFORMATION OM ÅNGERRÄTT',
    blocks: [
      {
        type: 'p',
        text: 'Din ångerrätt gäller under 14 dagar i enlighet med Distansavtalslagen. Ångerfristen börjar löpa den dag du tog emot varan eller en väsentlig del av den. Om köpet gäller en specialtillverkad vara eller en vara som fått en tydlig personlig prägel, börjar ångerfristen löpa den dag vi lämnat information till dig via orderbekräftelse, vanligen tillsänd via e-mail samt SMS.',
      },
    ],
  },
  {
    title: 'VILL DU VETA MER OM DE REGLER OCH RÅD SOM VI FÖLJER?',
    blocks: [
      {
        type: 'p',
        text: 'Du hittar information om distans- och hemförsäljningslagen på Konsumentverkets webbplats www.konsumentverket.se. Du kan också få information och rådgivning hos din kommunala konsumentvägledare. Sök på www.konsumentverket.se',
      },
    ],
  },
];
